import { SensorData } from 'Simulations/SensorPoint';
import { StageParameters, TransformStage } from '../../Stage';

export interface DiffuseRadiationStageParams extends StageParameters {
    isDiffuseRadiationOn: boolean;
    diffuseRadiationPercentage: number;
}

class DiffuseRadiationStage extends TransformStage<DiffuseRadiationStageParams> {
    override process(input: SensorData): SensorData {
        let value = input.getScalarValue();

        if (this.getParams().isDiffuseRadiationOn) value += value * this.getParams().diffuseRadiationPercentage;

        input.setScalarValue(value);
        return input;
    }
}

export default DiffuseRadiationStage;
